// extracted by mini-css-extract-plugin
module.exports = {"badgesContainer":"BB","badge":"BC","ratingLabel":"BD","subHeader":"BE","genre":"BF","rating":"BG"};